import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  sAvatar: "",
  s_nombre: "Anonymous",
  authority: ["USER"],
  s_correo: "",
  s_usuario: "",
  sk_usuario: "",
};

export const userSlice = createSlice({
  name: "auth/user",
  initialState,
  reducers: {
    setUser: (_, action) => action.payload,
    userLoggedOut: () => initialState,
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
